import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FrtRateFilingService {
  private baseURI = '/tmssserver/api';

  constructor(private http: HttpClient) { }

  /**
   * @description accepts/rejects the tsp status for FRT 0 for accept and 1 for reject
   */
  acceptRejectFrtTsp(payload) {
    return this.http.post(`/tmssserver/api/ratestspparticipation/saveTspParticipationRecords`, payload, {responseType: 'text'});
    // http://localhost:8380/tmssserver/api/public/ratestspparticipation/saveTspParticipationRecords/
  }

  /**
   * @description FRT gets the current FRT bid cycle
   */
  getCurrentFrtBidCycleInformation(businessType) {
    return this.http.get(this.baseURI + `/ratestspparticipation/currentFrtBidCycle/${businessType}/businessType`);
  }
  getTspParticipationSro(carrierId) {
    return this.http.get(this.baseURI + `/ratestspparticipation/getTspParticipationSro/${carrierId}/carrierId`);
  }

  getDocInfoForTsP(carrierId) {
    return this.http.get(this.baseURI + `/documentmanager/${carrierId}/carrierId`);
  }
}
